import React from 'react';
import { Card, Col, Row } from 'antd';
import {
  CalendarOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  ToolOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { FleetStatusFilterButton } from './FleetStatusFilterButton';

export default function FleetStatusPanel({
  maintSummary,
  serviceSummary,
  maintFilter,
  serviceFilter,
  setMaintFilter,
  setServiceFilter,
  dueSoonWindow,
  upcomingLabelEnd,
  unitLabel,
}) {
  return (
    <Row gutter={[16, 16]} className="customer-preview-status-row">
      <Col xs={24} lg={12}>
        <Card className="customer-preview-status-panel" title="Fleet Maintenance Status">
          <div className="customer-preview-status-grid">
            <FleetStatusFilterButton
              active={maintFilter === 'OVERDUE'}
              icon={<WarningOutlined />}
              label="Overdue"
              value={maintSummary.overdueCount}
              helper="Past service threshold"
              tone="danger"
              onClick={() => setMaintFilter(maintFilter === 'OVERDUE' ? 'ALL' : 'OVERDUE')}
            />
            <FleetStatusFilterButton
              active={maintFilter === 'DUE_SOON'}
              icon={<ClockCircleOutlined />}
              label={`Due soon (0-${dueSoonWindow}${unitLabel})`}
              mobileLabel="Due Soon"
              value={maintSummary.dueSoonCount}
              helper="Prioritize scheduling"
              tone="warning"
              onClick={() => setMaintFilter(maintFilter === 'DUE_SOON' ? 'ALL' : 'DUE_SOON')}
            />
            <FleetStatusFilterButton
              active={maintFilter === 'UPCOMING'}
              icon={<CalendarOutlined />}
              label={`Upcoming (${dueSoonWindow + 1}–${upcomingLabelEnd}${unitLabel})`}
              mobileLabel="Upcoming"
              value={maintSummary.upcomingCount}
              helper="Plan ahead"
              tone="info"
              onClick={() => setMaintFilter(maintFilter === 'UPCOMING' ? 'ALL' : 'UPCOMING')}
            />
          </div>
        </Card>
      </Col>

      <Col xs={24} lg={12}>
        <Card className="customer-preview-status-panel" title="Fleet Health Status">
          <div className="customer-preview-status-grid">
            <FleetStatusFilterButton
              active={serviceFilter === 'DOWN'}
              icon={<ToolOutlined />}
              label="Down"
              value={serviceSummary.downCount}
              helper="Out of service"
              tone="danger"
              onClick={() => setServiceFilter(serviceFilter === 'DOWN' ? 'ALL' : 'DOWN')}
            />
            <FleetStatusFilterButton
              active={serviceFilter === 'WAITING_ON_PARTS'}
              icon={<ClockCircleOutlined />}
              label="WAITING ON PARTS"
              mobileLabel="Waiting On Parts"
              value={serviceSummary.waitingPartsCount}
              helper="Awaiting parts"
              tone="warning"
              onClick={() =>
                setServiceFilter(
                  serviceFilter === 'WAITING_ON_PARTS' ? 'ALL' : 'WAITING_ON_PARTS'
                )
              }
            />
            <FleetStatusFilterButton
              active={serviceFilter === 'IN_SERVICE'}
              icon={<CheckCircleOutlined />}
              label="In service"
              value={serviceSummary.inServiceCount}
              helper="Available now"
              tone="success"
              onClick={() => setServiceFilter(serviceFilter === 'IN_SERVICE' ? 'ALL' : 'IN_SERVICE')}
            />
          </div>
        </Card>
      </Col>
    </Row>
  );
}
